"use client"
import { useAppSelector } from "@/lib/redux/hooks"

import { Card, Col, Row, Skeleton, Switch } from "antd"
import { FC, useRef } from "react"

type SelectDateSkeletonProps = {
  isReturn?: boolean,
  size?: 'small' | 'default',
}

const SelectDateSkeleton: FC<SelectDateSkeletonProps> = ({ size = 'default', isReturn }) => {

  const ref = useRef<HTMLDivElement>(null)
  const checkedItinerary = useAppSelector(state => state.flight.checkedItinerary)

  const isSmall = size === 'small'

  return (
    <Card
      ref={ref}
      size='small'
      className={`home__searching--date${!checkedItinerary && isReturn ? ' home__searching--date-disabled' : ''}`}
    >
      <Row style={{ marginBottom: 5 }} justify='space-between' className="home__searching--input-label" align='middle' gutter={[5, 5]} wrap={false}>
        <Col>
          <Skeleton
            active
            styles={{
              title: {
                width: '7.7rem',
                height: isSmall ? '2rem' : '2.2rem',
                margin: 0
              }
            }}
            paragraph={false}
          />
        </Col>
        {isReturn && (
          <Col>
            <Switch
              value={checkedItinerary}
              size='small'
            />
          </Col>
        )}

      </Row>
      <Row style={isSmall ? { height: '2.1rem' } : { paddingBlock: '0.5rem' }}>
        <Col span={24} style={isSmall ? { height: '2.1rem' } : {}}>
          <Skeleton.Input style={isSmall ? { height: '2.1rem' } : {}} block active size='large' />
        </Col>
      </Row>
      {size === 'default' && (
        <Row>
          <Skeleton
            paragraph={false}
            active
            styles={{
              title: {
                margin: 0,
                height: '2.5rem'
              }
            }}
          />
        </Row>
      )}
    </Card>
  )
}

export default SelectDateSkeleton